import { TranslationService } from '../Translation'
import { BaseNavigation } from './baseNavigation'

export class HomeNavigation extends BaseNavigation {
	static homeRoute: string = '/home'

	static get route(): string {
		const translation = TranslationService.getInstance()
		return `/${translation.getLocale()}${this.homeRoute}/`
	}

	static toHome(): unknown {
		return this.navigateTo(this.route)
	}

	static getBasePageUrl(): string {
		return 'https://www.passporterapp.com'
	}

	static toBasePage(): unknown {
		return this.navigateTo(this.getBasePageUrl(), true)
	}
}
